import { createVNode as o, mergeProps as d } from "vue";
import l from "../node_modules/@pf-ui/pf-icon-svg/es/asn/YesFilledStandard.js";
import s from "../components/PfIcon.js";
const r = (e, t) => {
  const a = {
    ...e,
    ...t.attrs
  };
  return o(s, d(a, {
    icon: l
  }), null);
};
r.displayName = "YesFilledStandard";
r.inheritAttrs = !1;
export {
  r as default
};
